import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import styled from 'styled-components';
import {
  FormField,
  HelpBlock,
  Label,
  Row,
} from './form';
import SingleDatePickerWrapper from '../../../shared/single-date-picker-wrapper';

const SFormField = styled(FormField)`
  .DateInput_input {
    height: 40px !important;
    padding: 8px 16px !important;
  }

  svg.DateInput_fang, .SingleDatePicker_picker {
    margin-top: -12px;
  }
`;

export default function withNameDatepicker(objectName, name, store, label) {
  const kebab = _.kebabCase(name);
  const capitalize = _.capitalize(name);
  const snake = _.snakeCase(name);

  function PlainDatepicker() {
    const set = store(state => state.set);
    const date = store(state => state[objectName][name]);
    const errors = store(state => state.errors);

    const onDateChange = d => {
      set(state => {
        state[objectName][name] = d;
      });
    };

    return (
      <Row>
        <Label htmlFor={kebab}>{label || name}</Label>
        <SFormField>
          <SingleDatePickerWrapper
            initialDate={date ? moment(date) : null}
            onDateChange={onDateChange}
            isOutsideRange={() => false}
          />
          {!!errors[snake] && <HelpBlock>{errors[snake]}</HelpBlock>}
        </SFormField>
      </Row>
    );
  }

  PlainDatepicker.displayName = capitalize;

  return PlainDatepicker;
}
